import { render, staticRenderFns } from "./HandleModal.vue?vue&type=template&id=d033bb06"
import script from "./HandleModal.vue?vue&type=script&lang=js"
export * from "./HandleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports